<div *ngIf="from && till">
  {{ from?.toString() | date: 'dd.MM.yyyy HH:mm' }} - {{ till?.toString() | date: 'dd.MM.yyyy HH:mm' }}
</div>
<div *ngIf="!from && till">
  {{ 'lang.template.till' | translate }}{{ till?.toString() | date: 'dd.MM.yyyy HH:mm' }}
</div>
<div *ngIf="from && !till">
  {{ 'lang.template.from' | translate }}{{ from?.toString() | date: 'dd.MM.yyyy HH:mm' }}
</div>
<div *ngIf="!from && !till">
  {{ 'lang.globals.indefinitelyValid' | translate }}
</div>
